// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import { getCookie } from "./assets/js/cookie";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import "./assets/js/main";

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
const i18n = new VueI18n({
  // locale: 'zh', // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
  locale: getCookie("PLAY_LANG", "en"),
  messages: {
    zh: require("./VueI18n/language-zh"), //
    en: require("./VueI18n/language-en"),
  },
});
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js